/*
 * Purpose: Append-only mission dossier sync — POST new entries to API
 * Last modified: 2026-06-28 | Agent
 * Completeness: 95
 */
import { apiUrl } from '@/lib/apiBase';
import type { MissionDossierEntry } from './types';

export async function appendMissionDossierOnServer(
  missionSessionId: string,
  entries: MissionDossierEntry[]
): Promise<{ ok: boolean; appended?: number; message?: string }> {
  if (!missionSessionId || entries.length === 0) return { ok: true, appended: 0 };

  try {
    const res = await fetch(apiUrl(`/api/missions/${encodeURIComponent(missionSessionId)}/dossier/append`), {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ entries }),
    });
    const body = (await res.json()) as { ok?: boolean; appended?: number; message?: string; error?: string };
    if (!res.ok) {
      return { ok: false, message: body.error ?? `Dossier sync failed (${res.status})` };
    }
    return { ok: true, appended: body.appended ?? entries.length, message: body.message };
  } catch (e) {
    return {
      ok: false,
      message: e instanceof Error ? e.message : 'Dossier sync failed',
    };
  }
}

export async function fetchMissionDossierFromServer(
  missionSessionId: string
): Promise<{ ok: boolean; entries?: MissionDossierEntry[]; message?: string }> {
  if (!missionSessionId) return { ok: false, message: 'No mission session' };

  try {
    const res = await fetch(apiUrl(`/api/missions/${encodeURIComponent(missionSessionId)}/dossier`), {
      credentials: 'include',
    });
    const body = (await res.json()) as { ok?: boolean; entries?: MissionDossierEntry[]; error?: string };
    if (!res.ok) {
      return { ok: false, message: body.error ?? `Dossier fetch failed (${res.status})` };
    }
    return { ok: true, entries: body.entries ?? [] };
  } catch (e) {
    return {
      ok: false,
      message: e instanceof Error ? e.message : 'Dossier fetch failed',
    };
  }
}
